// extracted by mini-css-extract-plugin
export var active = "_gu-2";
export var recordingDot = "_gu-1";
export var recordingIndicator = "_gu-0";